import { SportsbookConnection, SDQueryBuilder } from "./C_Sportsbook";
import { CaptorConnection } from "./C_Captor";
import { RealityCheckConnection } from "./C_RealityCheck";
import { SearchConnection } from "./C_Search";
import { BetslipConnection } from "./C_Betslip";
import { PlayerDataConnection } from "./C_PlayerData";
import { BetsReportingConnection } from "./C_BetsReporting";
import { CasinoConnection } from "./C_Casino";
import { casinoPlayerActivityAPIConnection } from "./C_CasinoPlayerActivityAPI";
export { SD, BS, Captor, RC, Search, BReporting, Player, Casino } from "./Contracts";
export const Sportsbook = {
    connection: SportsbookConnection,
    queryBuilder: SDQueryBuilder
};
export const Betslip = {
    connection: BetslipConnection
};
export const CaptorData = {
    connection: CaptorConnection
};
export const RealityCheck = {
    connection: RealityCheckConnection
};
export const SearchData = {
    connection: SearchConnection
};
export const BetsReporting = {
    connection: BetsReportingConnection
};
export const PlayerData = {
    connection: PlayerDataConnection
};
export const CasinoData = {
    connection: CasinoConnection
};
export const CasinoPlayerActivity = {
    connection: casinoPlayerActivityAPIConnection
};
export { init } from "./App";
if (process.env.NODE_ENV === "development") {
    const { demo } = require("./Examples");
    module.exports = Object.assign(Object.assign({}, module.exports), { demo });
}
//# sourceMappingURL=index.js.map